import { render, staticRenderFns } from "./solicitud-completada.vue?vue&type=template&id=121c9c50"
import script from "./solicitud-completada.vue?vue&type=script&lang=js"
export * from "./solicitud-completada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports